<template>
  <v-container>
    <v-simple-table fixed-header height="90vh" class="elevation-2">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="subtitle-1 text-center" style="width:10px;">Numero</th>
            <th class="text-left subtitle-1" style="width:300px;">Nombre</th>
            <th class="subtitle-1 text-left" style="width:150px">Teléfono</th>
            <th class="subtitle-1 text-left">Correo</th>
            <th class="subtitle-1 text-left">Dirección</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="notario in notarios" :key="notario.name">
            <td class="body-1 text-center">{{ notario.numero }}</td>
            <td>{{ notario.nombre }}</td>
            <td>
              <a :href="`tel:${notario.telefono}`">{{ notario.telefono }}</a>
            </td>
            <td>
              <a :href="`mailto:${notario.email}`">{{ notario.email }}</a>
            </td>
            <td>{{ notario.direccion }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-container>
</template>

<script>
import notarios from "@/assets/notarios.json";
export default {
  name: "HelloWorld",

  data: () => ({}),
  computed: {
    notarios() {
      return notarios;
    }
  }
};
</script>
